/**
 * activists
 */
'use strict';
import AppActivists from '@/_modules/app_activists';

document.addEventListener('DOMContentLoaded', () => {
  new AppActivists();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);
